module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_2.e72a5d0a.pdf";